// src/chainflip.ts
var chainflipAssets = [
  // Ethereum
  "Usdc",
  "Usdt",
  "Flip",
  "Eth",
  // Polkadot
  "Dot",
  // Bitcoin
  "Btc",
  // Arbitrum
  "ArbUsdc",
  "ArbEth",
  // Solana
  "Sol",
  "SolUsdc",
  // Assethub
  "HubDot",
  "HubUsdt",
  "HubUsdc"
];
var assetSymbols = ["USDC", "USDT", "FLIP", "DOT", "ETH", "BTC", "SOL"];
var rpcAssets = assetSymbols;
var baseChainflipAssets = chainflipAssets.filter(
  (asset) => asset !== "Usdc"
);
var chainflipEvmChains = ["Ethereum", "Arbitrum"];
var chainflipChains = [
  ...chainflipEvmChains,
  "Bitcoin",
  "Polkadot",
  "Solana",
  "Assethub"
];
var chainflipNetworks = ["backspin", "sisyphos", "perseverance", "mainnet"];
var addressTypes = ["Eth", "Btc", "Dot", "Arb", "Sol", "Hub"];
function readAssetValue(map, asset) {
  const chainValues = map[assetConstants[asset].chain];
  return chainValues[assetConstants[asset].symbol];
}
var assetConstants = {
  Eth: {
    chain: "Ethereum",
    symbol: "ETH",
    rpcAsset: "ETH",
    decimals: 18
  },
  Flip: {
    chain: "Ethereum",
    symbol: "FLIP",
    rpcAsset: "FLIP",
    decimals: 18
  },
  Usdc: {
    chain: "Ethereum",
    symbol: "USDC",
    rpcAsset: "USDC",
    decimals: 6
  },
  Usdt: {
    chain: "Ethereum",
    symbol: "USDT",
    rpcAsset: "USDT",
    decimals: 6
  },
  Dot: {
    chain: "Polkadot",
    symbol: "DOT",
    rpcAsset: "DOT",
    decimals: 10
  },
  Btc: {
    chain: "Bitcoin",
    symbol: "BTC",
    rpcAsset: "BTC",
    decimals: 8
  },
  ArbUsdc: {
    chain: "Arbitrum",
    symbol: "USDC",
    rpcAsset: "USDC",
    decimals: 6
  },
  ArbEth: {
    chain: "Arbitrum",
    symbol: "ETH",
    rpcAsset: "ETH",
    decimals: 18
  },
  Sol: {
    chain: "Solana",
    symbol: "SOL",
    rpcAsset: "SOL",
    decimals: 9
  },
  SolUsdc: {
    chain: "Solana",
    symbol: "USDC",
    rpcAsset: "USDC",
    decimals: 6
  },
  HubDot: {
    chain: "Assethub",
    symbol: "DOT",
    rpcAsset: "DOT",
    decimals: 10
  },
  HubUsdc: {
    chain: "Assethub",
    symbol: "USDC",
    rpcAsset: "USDC",
    decimals: 6
  },
  HubUsdt: {
    chain: "Assethub",
    symbol: "USDT",
    rpcAsset: "USDT",
    decimals: 6
  }
};
var chainConstants = {
  Ethereum: {
    chainflipAssets: ["Eth", "Flip", "Usdc", "Usdt"],
    assets: ["ETH", "FLIP", "USDC", "USDT"],
    rpcAssets: ["ETH", "FLIP", "USDC", "USDT"],
    gasAsset: "Eth",
    addressType: "Eth",
    blockTimeSeconds: 12
  },
  Polkadot: {
    chainflipAssets: ["Dot"],
    assets: ["DOT"],
    rpcAssets: ["DOT"],
    gasAsset: "Dot",
    addressType: "Dot",
    blockTimeSeconds: 6
  },
  Bitcoin: {
    chainflipAssets: ["Btc"],
    assets: ["BTC"],
    rpcAssets: ["BTC"],
    gasAsset: "Btc",
    addressType: "Btc",
    blockTimeSeconds: 10 * 60
  },
  Arbitrum: {
    chainflipAssets: ["ArbUsdc", "ArbEth"],
    assets: ["USDC", "ETH"],
    rpcAssets: ["USDC", "ETH"],
    gasAsset: "ArbEth",
    addressType: "Arb",
    blockTimeSeconds: 0.26
  },
  Solana: {
    chainflipAssets: ["Sol", "SolUsdc"],
    assets: ["SOL", "USDC"],
    rpcAssets: ["SOL", "USDC"],
    gasAsset: "Sol",
    addressType: "Sol",
    blockTimeSeconds: 0.8
  },
  Assethub: {
    chainflipAssets: ["HubDot", "HubUsdt", "HubUsdc"],
    assets: ["DOT", "USDT", "USDC"],
    rpcAssets: ["DOT", "USDT", "USDC"],
    gasAsset: "HubDot",
    addressType: "Hub",
    blockTimeSeconds: 12
  }
};
var internalAssetToRpcAsset = {
  Eth: { chain: "Ethereum", asset: "ETH" },
  Flip: { chain: "Ethereum", asset: "FLIP" },
  Usdc: { chain: "Ethereum", asset: "USDC" },
  Usdt: { chain: "Ethereum", asset: "USDT" },
  Dot: { chain: "Polkadot", asset: "DOT" },
  Btc: { chain: "Bitcoin", asset: "BTC" },
  ArbUsdc: { chain: "Arbitrum", asset: "USDC" },
  ArbEth: { chain: "Arbitrum", asset: "ETH" },
  Sol: { chain: "Solana", asset: "SOL" },
  SolUsdc: { chain: "Solana", asset: "USDC" },
  HubDot: { chain: "Assethub", asset: "DOT" },
  HubUsdt: { chain: "Assethub", asset: "USDT" },
  HubUsdc: { chain: "Assethub", asset: "USDC" }
};
var chainContractId = {
  Ethereum: 1,
  Polkadot: 2,
  Bitcoin: 3,
  Arbitrum: 4,
  Solana: 5,
  Assethub: 6
};
var assetContractId = {
  Eth: 1,
  Flip: 2,
  Usdc: 3,
  Usdt: 8,
  Dot: 4,
  Btc: 5,
  ArbEth: 6,
  ArbUsdc: 7,
  Sol: 9,
  SolUsdc: 10,
  HubDot: 11,
  HubUsdt: 12,
  HubUsdc: 13
};
function isValidAssetAndChain(assetAndChain) {
  const { asset, chain } = assetAndChain;
  if (!(chain in chainConstants)) return false;
  const validAssets = chainConstants[chain].assets;
  return validAssets.includes(asset);
}
function getInternalAsset(asset, assert = true) {
  if (!isValidAssetAndChain(asset)) {
    if (assert) {
      throw new Error(`invalid asset and chain combination: ${JSON.stringify(asset)}`);
    }
    return null;
  }
  const map = {
    Ethereum: {
      USDC: "Usdc",
      FLIP: "Flip",
      ETH: "Eth",
      USDT: "Usdt"
    },
    Bitcoin: {
      BTC: "Btc"
    },
    Polkadot: {
      DOT: "Dot"
    },
    Arbitrum: {
      USDC: "ArbUsdc",
      ETH: "ArbEth"
    },
    Solana: {
      SOL: "Sol",
      USDC: "SolUsdc"
    },
    Assethub: {
      USDC: "HubUsdc",
      USDT: "HubUsdt",
      DOT: "HubDot"
    }
  };
  const chain = map[asset.chain];
  return chain[asset.asset];
}
function getInternalAssets({
  srcAsset,
  srcChain,
  destAsset,
  destChain
}, assert = true) {
  return {
    srcAsset: getInternalAsset({ asset: srcAsset, chain: srcChain }, assert),
    destAsset: getInternalAsset({ asset: destAsset, chain: destChain }, assert)
  };
}

export {
  chainflipAssets,
  assetSymbols,
  rpcAssets,
  baseChainflipAssets,
  chainflipEvmChains,
  chainflipChains,
  chainflipNetworks,
  addressTypes,
  readAssetValue,
  assetConstants,
  chainConstants,
  internalAssetToRpcAsset,
  chainContractId,
  assetContractId,
  isValidAssetAndChain,
  getInternalAsset,
  getInternalAssets
};
